"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlActiveSessionAttemptsSerialization = void 0;
const ChargingSessionAttemptSerialization_1 = require("./ChargingSessionAttemptSerialization");
class ChargerControlActiveSessionAttemptsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.attempts = entity.attempts?.map((field) => field
            ? JSON.parse(ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.attempts = entity.attempts?.map((field) => field
            ? ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlActiveSessionAttemptsSerialization = ChargerControlActiveSessionAttemptsSerialization;
